import React from "react";
import { HubSpotEmbedForm } from "~/molecules/HubSpotEmbedForm";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";

type Props = {
  hubspotFormId?: string | null;
};

export const ContactApplicationForm: React.FC<Props> = ({ hubspotFormId }) => {
  return (
    <>
      <style jsx>{`
        .formCard {
          background: ${colors.white};
          border: 1px solid ${colors.gray3};
          border-radius: 16px;
          box-sizing: border-box;
          padding: 28px 24px 24px;
          width: 100%;
        }
        @media (${breakPoints.sp}) {
          .formCard {
            border-radius: 12px;
            padding: 22px 18px 18px;
          }
        }
      `}</style>
      <div className="formCard" data-hubspot-form-scroll-anchor>
        <HubSpotEmbedForm hubspotFormId={hubspotFormId} variant="contact" />
      </div>
    </>
  );
};
